import actions from '../../lib/api/actions';

export async function fetchShifts({ commit }) {
  const response = await actions.fetchShifts();

  if (response.status === 200) {
    commit('updateShifts', response.data.data.shifts);
  }
}

export async function updateShiftEmployeeStatus({ dispatch }, payload) {
  const response = await actions.updateShiftEmployeeStatus(payload);

  if (response.status === 200) {
    dispatch('fetchShifts');
  }
}
